import { searchPathBuilder } from './types';

export const getNewPath = (builder: searchPathBuilder): string => {
    const slug = [builder.host, builder.searchType];
    if (builder.maps) slug.push('map');
    slug.push(builder.propertyType, ...builder.extra);

    return slug.join('/');
};
